import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const painPoints = ['Estás CANSADA de pararte frente al refrigerador a las 6 PM sin saber qué darle al bebé.', 'Buscas alimentar a tu bebé saludable, pero te FRENA el miedo al atragantamiento o las alergias.', 'Te ABRUMA recibir consejos contradictorios del WhatsApp familiar, TikTok y la pediatra.', 'Estás cansada de COMPRAR potitos caros que tu bebé rechaza al primer bocado.', 'Quieres dejar de cocinar DOS veces al día (una para ti, otra para el bebé).'];
export function PainPoints() {
  return <section className="py-10 md:py-20 px-5 md:px-6 bg-white" data-id="element-122">
      <div className="max-w-4xl mx-auto" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-14" data-id="element-124">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D1F1A] leading-tight tracking-tight" data-id="element-125">
            ESTE SISTEMA{' '}
            <em className="text-[#F9A8B7] not-italic" data-id="element-126">ES PARA TI</em> SI…
          </h2>
        </motion.div>
        <div className="space-y-3 md:space-y-4" data-id="element-127">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-start gap-3 md:gap-4 p-4 md:p-6 rounded-2xl bg-[#FFF1F4] border border-[#F9A8B7]/20 hover:border-[#F9A8B7]/50 transition-colors" data-id="element-128">
              <div className="flex-shrink-0 mt-1" data-id="element-129">
                <div className="bg-[#F9A8B7]/20 p-1.5 rounded-full" data-id="element-130">
                  <XIcon className="w-4 h-4 md:w-5 md:h-5 text-[#F9A8B7]" strokeWidth={3} data-id="element-131" />
                </div>
              </div>
              <p className="text-base md:text-xl text-gray-800 leading-snug md:leading-[1.6]" data-id="element-132">
                {point}
              </p>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-8 md:mt-12 p-5 md:p-7 bg-[#A9D7E2]/20 rounded-2xl border-2 border-[#A9D7E2]/40 flex items-start gap-3 md:gap-4" data-id="element-133">
          <div className="flex-shrink-0 mt-1" data-id="element-134">
            <div className="bg-[#A9D7E2] p-1.5 rounded-full" data-id="element-135">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-white" strokeWidth={3} data-id="element-136" />
            </div>
          </div>
          <p className="text-lg md:text-2xl font-bold text-[#2D1F1A] leading-snug" data-id="element-137">
            Si dijiste{' '}
            <span className="underline decoration-[#A9D7E2] decoration-4 underline-offset-4" data-id="element-138">
              SÍ a uno solo
            </span>{' '}
            de estos puntos,{' '}
            <em className="text-[#F9A8B7] not-italic" data-id="element-139">
              esta página es para ti.
            </em>
          </p>
        </motion.div>
      </div>
    </section>;
}